import useLlmFeatures from "ai-management/token-usage/hooks/useLlmFeatures";
const useFeatureTitles = () => {
  const { data: features } = useLlmFeatures();
  return (featureId) => {
    var _a, _b;
    return (_b = (_a = features.find(({ id }) => id === featureId)) == null ? void 0 : _a.title) != null ? _b : featureId;
  };
};
export default useFeatureTitles;
